import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { ElectionProgVal } from '../models/electionProgVal';
import { environment } from '../../environments/environment.prod';


@Injectable()
export class ElectionprogramscheduleService {

  headers: Headers;
  options: RequestOptions;

  // BaseUrl = environment.config.baseUrlDotNet;
  BaseUrl= "https://webapi.truevoter.in/api";
  BaseUrl1 = environment.config.baseUrlDhananjoy;


  constructor(private _http: Http) {
    this.headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
    this.options = new RequestOptions({ headers: this.headers });
  }

  downloadHolidayList() {
    // https://webapi.truevoter.in/api/ElectionProgram/getholidaylist
    return this._http.get(this.BaseUrl + '/ElectionProgram/getholidaylist').map(res => res.json());
  }

  downloadElectionProgValue() {
    return this._http.get(this.BaseUrl + '/getelectionprogval?epId=1').map(res => res.json());
  }

  saveElectionSchedule(data: ElectionProgVal) {
    return this._http.post(this.BaseUrl + '/saveelectionschedule', JSON.stringify(data), this.options)
      .map(res => res.json());
  }

  // download election program schedule
  downloadElectionProgramSchedule(id: number) {
    return this._http.get(this.BaseUrl + '/ElectionProgram/getelectionprogramscheduledate?id=' + id)
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/electionprogramschedule.service.ts